import ReportsBoxColumn from "./ReportsBoxColumn";
import Loading from "../../components/Loading";
import {useSelector} from "react-redux";
import {selectReportingBoxData} from "./reportSlice";
import {selectIsPending} from "../common-states/commonStatesSlice";

const ReportsBox = () => {
    const reportingBoxData = useSelector(selectReportingBoxData)
    const isPending = useSelector(selectIsPending)
    return(
        <div className='reports-box'>
            <ReportsBoxColumn firstRowReport='تعداد کل درخواست ها:' data={reportingBoxData[2]} />
            <ReportsBoxColumn firstRowReport='تعداد درخواست های آب شرب:' waterType='آب شرب' data={reportingBoxData[1]} />
            <ReportsBoxColumn firstRowReport='تعداد درخواست های آب دام:' waterType='آب دام' data={reportingBoxData[0]} />
            {isPending && <Loading />}
        </div>
    )
}

export default ReportsBox